var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAk2784343430(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200.9 30",
    style: {
      enableBackground: "new 0 0 200.9 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 59.7,
    y: 7.3,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 4.9758 35.6086)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.9,
    y: 7.4,
    transform: "matrix(0.4979 -0.8672 0.8672 0.4979 18.3079 74.5297)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.2,
    y: 11.2,
    width: 3.5,
    height: 7.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1,30H57.4V0.4h29.7V30z M58.5,28.9H86V1.5H58.5V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2,26H60.8V4h22.5V26z M61.9,24.8h20.2V5.1H61.9V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.4,
    y: 7.3,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 18.3484 89.112)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.7,
    y: 7.4,
    transform: "matrix(0.4981 -0.8671 0.8671 0.4981 75.3731 173.1234)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 11.2,
    width: 3.5,
    height: 7.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.8,30h-29.7V0.4h29.7V30z M172.2,28.9h27.5V1.5h-27.5V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.9,26h-22.5V4h22.5V26z M175.6,24.8h20.2V5.1h-20.2V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.6,
    y: 7.3,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 -1.734 8.763)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.9,
    y: 7.4,
    transform: "matrix(0.4981 -0.8671 0.8671 0.4981 -10.3458 25.035)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.2,
    y: 11.2,
    width: 3.5,
    height: 7.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1,30H0.3V0.4h29.7V30z M1.4,28.9h27.5V1.5H1.4V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1,26H3.7V4h22.5V26z M4.8,24.8H25V5.1H4.8V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.1,
    y: 7.3,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 15.0177 75.7861)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.3,
    y: 7.4,
    transform: "matrix(0.4979 -0.8672 0.8672 0.4979 61.1844 148.5868)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.5,30h-29.7V0.4h29.7V30z M143.9,28.9h27.5V1.5h-27.5V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.6,26h-22.5V4h22.5V26z M147.3,24.8h20.2V5.1h-20.2V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.5,
    y: 7.3,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 11.6534 62.3255)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.7,
    y: 7.4,
    transform: "matrix(0.4979 -0.8672 0.8672 0.4979 46.8194 123.7754)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 11.2,
    width: 3.5,
    height: 7.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.9,30h-29.7V0.4h29.7V30z M115.3,28.9h27.5V1.5h-27.5V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,26h-22.5V4H140V26z M118.7,24.8h20.2V5.1h-20.2V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.2,
    y: 7.3,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 8.324 49.0047)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.4,
    y: 7.4,
    transform: "matrix(0.4981 -0.8671 0.8671 0.4981 32.586 99.2036)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.6,30H85.8V0.4h29.7V30z M87,28.9h27.5V1.5H87V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.7,26H89.2V4h22.5V26z M90.4,24.8h20.2V5.1H90.4V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.2,
    y: 7.3,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 1.6289 22.218)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 7.4,
    transform: "matrix(0.4979 -0.8672 0.8672 0.4979 4.0172 49.847)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7,30H28.9V0.4h29.7V30z M30.1,28.9h27.5V1.5H30.1V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8,26H32.3V4h22.5V26z M33.5,24.8h20.2V5.1H33.5V24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1,28.5c-0.2,0-0.4-0.1-0.5-0.3l-2-4.1c-0.1-0.3,0-0.6,0.3-0.8c0.3-0.1,0.6,0,0.8,0.3l2,4.1c0.1,0.3,0,0.6-0.3,0.8 L29.1,28.5z M25.5,21.4c-0.2,0-0.4-0.1-0.5-0.3l-2-4.1c-0.1-0.3,0-0.6,0.3-0.8c0.3-0.1,0.6,0,0.8,0.3l2,4.1c0.1,0.3,0,0.6-0.3,0.8 L25.5,21.4z M21.9,14.2c-0.2,0-0.4-0.1-0.5-0.3l-2-4.1c-0.1-0.3,0-0.6,0.3-0.8c0.3-0.1,0.6,0,0.8,0.3l2,4.1c0.1,0.3,0,0.6-0.3,0.8 L21.9,14.2z M18.4,7.1c-0.2,0-0.4-0.1-0.5-0.3l-2-4.1c-0.1-0.3,0-0.6,0.3-0.8c0.3-0.1,0.6,0,0.8,0.3l2,4.1c0.1,0.3,0,0.6-0.3,0.8 L18.4,7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.6,29.6l-0.3-0.1c-0.3-0.1-0.4-0.5-0.2-0.8l2.1-4c0.1-0.3,0.5-0.4,0.8-0.2c0.3,0.1,0.4,0.5,0.2,0.8l-2.1,4 C1,29.5,0.8,29.6,0.6,29.6z M4.2,22.5L4,22.5c-0.3-0.1-0.4-0.5-0.2-0.8l2.1-4c0.1-0.3,0.5-0.4,0.8-0.2c0.3,0.1,0.4,0.5,0.2,0.8 l-2.1,4C4.7,22.4,4.5,22.5,4.2,22.5z M7.9,15.5l-0.3-0.1c-0.3-0.1-0.4-0.5-0.2-0.8l2.1-4c0.1-0.3,0.5-0.4,0.8-0.2 c0.3,0.1,0.4,0.5,0.2,0.8l-2.1,4C8.3,15.4,8.1,15.5,7.9,15.5z M11.6,8.4l-0.3-0.1c-0.3-0.1-0.4-0.5-0.2-0.8l2.1-4 c0.1-0.3,0.5-0.4,0.8-0.2c0.3,0.1,0.4,0.5,0.2,0.8l-2.1,4C12,8.3,11.8,8.4,11.6,8.4z M15.3,1.3L15,1.3c-0.3-0.1-0.4-0.5-0.2-0.8 l0.1-0.2C15,0,15.4-0.1,15.6,0.1c0.3,0.1,0.4,0.5,0.2,0.8L15.8,1C15.7,1.2,15.5,1.3,15.3,1.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAk2784343430);
export default __webpack_public_path__ + "static/media/AK2_7_8434343_0.ebddd45281a072006fb09b177a95fc93.svg";
export { ForwardRef as ReactComponent };